import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

import { RewardsStyleVariant, WithStyleVariant } from '../types';

const RewardsTitleContainer = styled.div<WithStyleVariant>`
  width: 100%;
  margin: 0 0 ${primitive.$spacing4} 0;

  font: ${brandFont.headerThree};
  line-height: inherit;
  color: ${({ variant, theme }) =>
    variant === RewardsStyleVariant.Secondary
      ? theme.token('text-reversed')
      : theme.token('text-default')};
`;

const RewardPoints = styled.div`
  font-size: 1.5rem;
`;

const RewardCateogryDropdownHeader: React.FC<{ points?: number } & WithStyleVariant> = ({
  variant = RewardsStyleVariant.Primary,
  points = 0,
}) => {
  const { formatMessage } = useIntl();
  return (
    <RewardsTitleContainer variant={variant} tabIndex={0}>
      <div>{formatMessage({ id: 'loyaltyHelp' })}</div>
      <RewardPoints>{formatMessage({ id: 'loyaltyDropdownPoints' }, { points })}</RewardPoints>
    </RewardsTitleContainer>
  );
};

export default RewardCateogryDropdownHeader;
